import React, { useEffect, useState, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import translate from "../../../i18n/translate";
import { useHistory } from "react-router-dom";
import SubNavOoredoo from "./SubNavOoredoo";
import {
  getOoredoo3g,
  getOoredoo3gRenew,
  getOoredoo3gNotRenew,
} from "../../../actions/companiesAction";
import Selected from "./Selected";
import Badge from "../../ui/Badge/Badge";
import _ from "lodash";
import "./ooredoo.css";
import { dataLanguage } from "../../../i18n/translateRequest";
import CompaniesNav from "../../common/CompaniesNav";
import logo from "../../../assests/images/bundles/ooredoo/banner.jpg";
import { jsonParser } from "shared/utils/ppUtils";
import getOoredooCachedImageUrl from "shared/utils/ooredooImageCache";
import { Box, Tabs, Tab } from "@mui/material";
import OoredooBundleCard from "./OoredooBundleCard";

const Ooredoo3g = ({
  getOoredoo3g,
  loading,
  ooredoo3g,
  getOoredoo3gNotRenew,
  getOoredoo3gRenew,
  isDarkTheme,
}) => {
  const intl = useIntl();
  const history = useHistory().location.pathname;
  const mobileNo = history.split("/")[4];

  const [isRenew, setIsRenew] = useState(false);
  const [isNotRenew, setIsNotRenew] = useState(false);
  const [init, isInit] = useState(false);

  const [g3, setG3] = useState("");
  const [min, setMin] = useState("");
  const [credit, setCredit] = useState("");
  const [creditQueue, setCreditQueue] = useState([]);
  const [rom, setRom] = useState("");
  const [shabab, setShabab] = useState("");
  const [groupedBundles, setGroupedBundles] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("");
  const [columnStyle, setColumnStyle] = useState(
    "col-lg-3 col-md-4 col-sm-6 col-6"
  );
  const [imageRefreshToken, setImageRefreshToken] = useState(0);

  const collapseRef = useRef([]);
  const listRef = useRef(null);

  const handleCreditQueueChange = (queue) => {
    setCreditQueue(queue || []);
    setCredit(queue?.[queue.length - 1] || "");
  };

  useEffect(() => {
    getOoredoo3g(false);

    const handleSessionStorageChange = () => {
      document.title = "Ooredoo  3G | Phone Play";

      if (sessionStorage.ooredoo3g) {
        setG3(jsonParser(sessionStorage.ooredoo3g));
      }
      if (sessionStorage.ooredooMin) {
        setMin(jsonParser(sessionStorage.ooredooMin));
      }
      // Load credit queue from sessionStorage
      if (sessionStorage.ooredooCreditQueue) {
        const parsedQueue = jsonParser(sessionStorage.ooredooCreditQueue);
        if (Array.isArray(parsedQueue) && parsedQueue.length) {
          handleCreditQueueChange(parsedQueue);
        }
      } else if (sessionStorage.ooredooCredit) {
        const parsedCredit = jsonParser(sessionStorage.ooredooCredit);
        if (parsedCredit) {
          handleCreditQueueChange([parsedCredit]);
        }
      } else {
        handleCreditQueueChange([]);
      }
      if (sessionStorage.ooredooRom) {
        setRom(jsonParser(sessionStorage.ooredooRom));
      }
      if (sessionStorage.ooredooSuper) {
        setShabab(jsonParser(sessionStorage.ooredooSuper));
      }
      refreshColumnStyle();
    };
    handleSessionStorageChange();

    window.addEventListener(
      "sessionStorageChanged",
      handleSessionStorageChange
    );

    // Clean up the event listener
    return () => {
      window.removeEventListener(
        "sessionStorageChanged",
        handleSessionStorageChange
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileNo, history]);

  useEffect(() => {
    if (init) {
      getOoredooPackages();
    }
    isInit(true);

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRenew, isNotRenew]);

  // Group bundles by type field from backend
  useEffect(() => {
    if (Array.isArray(ooredoo3g) && ooredoo3g.length) {
      console.log("🔍 Ooredoo3g: Grouping bundles by type field");
      console.log("📦 Total bundles received:", ooredoo3g.length);
      
      // Check if bundles have type field
      const sampleBundle = ooredoo3g[0];
      console.log("📋 Sample bundle:", sampleBundle);
      console.log("🏷️ Sample bundle type:", sampleBundle?.type);
      
      const grouped = ooredoo3g.reduce((acc, bundle) => {
        // Use the type field from backend directly as key (TikTok, Social, 3G, etc.)
        // DO NOT translate here - translation happens only in display
        let bundleType = bundle?.type || "General";
        
        if (!acc[bundleType]) {
          acc[bundleType] = [];
        }
        acc[bundleType].push(bundle);
        return acc;
      }, {});
      
      console.log("📊 Grouped bundles:", Object.keys(grouped).map(cat => `${cat}: ${grouped[cat].length}`));
      
      setGroupedBundles(grouped);
      const availableCategories = Object.keys(grouped);
      
      // Default to "3G" category if available, otherwise first available
      if (!selectedCategory || !grouped[selectedCategory]) {
        const defaultCategory = availableCategories.includes("3G") 
          ? "3G" 
          : availableCategories[0];
        setSelectedCategory(defaultCategory);
        console.log(`📌 Setting default category to: ${defaultCategory}`);
      }
    } else {
      console.log("⚠️ Ooredoo3g: No bundles to group");
      setGroupedBundles({});
      setSelectedCategory("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ooredoo3g]);

  // Translate bundle type codes to display names (supports AR/EN/HE)
  const translateBundleType = (type) => {
    // Map of type codes to translation keys
    const typeToTranslationKey = {
      "3G": "3G", // Universal, no translation needed
      "TikTok": "TikTok", // Universal, no translation needed
      "Telegram": "Telegram",
      "Social": "Social",
      "6Months": "6 Months",
      "MIN": "Minutes",
      "LocalCalls": "Local Calls",
      "Credit": "Credit",
      "ROM": "Roaming",
      "YOUTH": "Youth",
      "General": "General"
    };
    
    // Get the translation key for this type
    const translationKey = typeToTranslationKey[type];
    
    if (!translationKey) {
      console.log(`🔄 No translation for type: "${type}", using original`);
      return type;
    }
    
    // For universal types (3G, TikTok), return as-is
    if (type === "3G" || type === "TikTok") {
      console.log(`🔄 Universal type: "${type}"`);
      return type;
    }
    
    // Use intl.formatMessage to get actual string translation
    const translatedStr = intl.formatMessage({ id: translationKey, defaultMessage: translationKey });
    console.log(`🔄 Translating type: "${type}" → "${translatedStr}"`);
    return translatedStr;
  };

  const orderedCategories = useMemo(() => {
    // Define the desired order
    const categoryOrder = [
      "3G",
      "TikTok",
      "Social",
      "6 Months",
      "Telegram",
      "Minutes",
      "Local Calls",
      "Credit"
    ];
    
    const categories = Object.keys(groupedBundles);
    console.log(`📋 Available categories:`, categories);
    console.log(`📊 Category counts:`, categories.map(cat => `${cat}: ${groupedBundles[cat]?.length || 0}`));
    
    const sorted = categories.sort((a, b) => {
      const indexA = categoryOrder.findIndex(cat => a.includes(cat) || cat.includes(a));
      const indexB = categoryOrder.findIndex(cat => b.includes(cat) || cat.includes(b));
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return a.localeCompare(b);
    });
    
    console.log(`✅ Ordered categories (${sorted.length}):`, sorted);
    console.log(`🎯 Will show tabs:`, sorted.length > 1);
    
    return sorted;
  }, [groupedBundles]);

  const currentCategoryBundles = useMemo(() => {
    if (!selectedCategory) return [];
    return groupedBundles[selectedCategory] || [];
  }, [groupedBundles, selectedCategory]);

  const handleClickOutside = (event) => {
    if (listRef.current && !listRef.current.contains(event.target)) {
      collapseRef.current.forEach((item) => {
        item?.classList?.remove("show");
      });
    }
  };

  const onTypeClick = (item) => {
    setG3(item);
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });

    sessionStorage.ooredoo3g = JSON.stringify(item);
  };

  const onRenewClick = () => {
    setIsRenew(!isRenew);
    setIsNotRenew(false);
    isInit(true);
  };
  const onNotRenewClick = () => {
    setIsNotRenew(!isNotRenew);
    setIsRenew(false);
    isInit(true);
  };
  const getOoredooPackages = () => {
    if (!isRenew && !isNotRenew) {
      getOoredoo3g(false);
    } else if (isRenew) {
      getOoredoo3gRenew();
    } else if (isNotRenew) {
      getOoredoo3gNotRenew();
    }
  };
  const refreshClick = () => {
    setImageRefreshToken(Date.now());
    getOoredoo3g(true);
  };

  const refreshColumnStyle = () => {
    switch (localStorage.size) {
      case "default":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
        break;
      case "column3":
        setColumnStyle("col-lg-4 col-md-6 col-sm-6 col-6 card-lg");
        break;
      case "column4":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6  card-md");
        break;
      case "column6":
        setColumnStyle("col-lg-2 col-md-2 col-sm-4 col-6 card-sm");
        break;
      default:
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
    }
  };
  let topDiv = null;

  return (
    <>
      <div ref={(ref) => (topDiv = ref)}>
        <div className="ooredoo-container">
          <CompaniesNav
            providerId={window?.history?.state?.state?.provider_Id}
            title="Ooredoo"
            logo={logo}
            mobile={mobileNo}
            onRefresh={refreshClick}
            actionWidth="300px"
            backLink="/company/ooredoo/MobileNumer"
          >
            <button
              type="button"
              className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
                isRenew ? "selected-btn" : ""
              }`}
              onClick={onRenewClick}
            >
              {translate("Renewable")}
            </button>
            <button
              type="button"
              className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
                isNotRenew ? "selected-btn" : ""
              }`}
              onClick={onNotRenewClick}
            >
              {translate("notRenew")}
            </button>
          </CompaniesNav>

          <div className="row">
            <div className="col-12">
              <SubNavOoredoo mobile={mobileNo} />
            </div>
          </div>
        </div>
        <div className="position-relative">
          <Selected
            min={min}
            setMin={setMin}
            g3={g3}
            setg3={setG3}
            credit={credit}
            setCredit={setCredit}
            creditQueue={creditQueue}
            onCreditQueueChange={handleCreditQueueChange}
            shabab={shabab}
            setShabab={setShabab}
            setRom={setRom}
            rom={rom}
            imageRefreshToken={imageRefreshToken}
          />

          <hr
            className="mt-3"
            style={{
              border: "2px solid #42ace3",
              backgroundColor: "#42ace3",
              fontWeight: "bolder",
            }}
          />

          <div
            className={`${isDarkTheme ? "dark-card" : "card"} list-cards p-4`}
            ref={listRef}
          >
            {/* Category Tabs */}
            {orderedCategories.length > 1 && (
              <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                <Tabs
                  value={selectedCategory}
                  onChange={(event, newValue) => setSelectedCategory(newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    "& .MuiTab-root": {
                      color: isDarkTheme ? "#fff" : "#000",
                      fontWeight: 500,
                      fontSize: "0.9rem",
                      minHeight: "48px",
                      textTransform: "none",
                    },
                    "& .Mui-selected": {
                      color: "#42ace3 !important",
                      fontWeight: 700,
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#42ace3",
                      height: "3px",
                    },
                  }}
                >
                  {orderedCategories.map((category) => {
                    const translatedName = String(translateBundleType(category));
                    const count = groupedBundles[category]?.length || 0;
                    return (
                      <Tab
                        key={category}
                        label={`${translatedName} (${count})`}
                        value={category}
                      />
                    );
                  })}
                </Tabs>
              </Box>
            )}

            {/* Bundle Cards */}
            <div className="row">
              {!_.isArray(currentCategoryBundles) && !loading ? (
                <div className="d-flex justify-content-center mt-3">
                  <h2 className="text-info">
                    {translate("No available bundles")}
                  </h2>
                </div>
              ) : currentCategoryBundles.length === 0 ? (
                <div className="d-flex justify-content-center mt-3 w-100">
                  <h4 className="text-muted">
                    {translate("No bundles in this category")}
                  </h4>
                </div>
              ) : (
                currentCategoryBundles.map((item, index) => (
                  <div key={index.toString()} className={`${columnStyle} mt-3`}>
                    <div
                      className={`${
                        isDarkTheme ? "dark-card" : "card"
                      } charge-card`}
                    >
                      <a
                        style={{ cursor: "pointer" }}
                        data-placement="top"
                        title={item && item.des}
                        onClick={() => onTypeClick(item)}
                      >
                        <div className="position-relative">
                          <OoredooBundleCard
                            item={item}
                            size={localStorage.size || "default"}
                          />
                          {(item.auto_renew === "True" ||
                            item.auto_renew === "true") && (
                            <Badge text={translate("Renewable")}></Badge>
                          )}
                        </div>
                      </a>
                    </div>
                    <div className={`${isDarkTheme ? "dark-card" : "card"}`}>
                      <div className="text-center" id="headingOne">
                        <h5 className="mb-0 mx-">
                          <a
                            href="#0"
                            className="link-main details"
                            style={{ fontWeight: "bolder" }}
                            data-toggle="collapse"
                            data-target={"#" + index}
                            aria-expanded="true"
                            aria-controls={index}
                          >
                            <small>{translate("Details")}</small>
                          </a>
                        </h5>
                      </div>

                      <div
                        id={index}
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                        ref={(el) => (collapseRef.current[index] = el)}
                      >
                        <div className="card-body">
                          {dataLanguage(item, "ar-des", "en-des", "he-des")}
                          <br />
                          <p style={{ textAlign: "center" }}>{item.bundleid}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  ooredoo3g: state.companies.ooredoo3g,
  loading: state.companies.loading,
  isDarkTheme: state.darkTheme.isDarktheme,
});

export default connect(mapStateToProps, {
  getOoredoo3g,
  getOoredoo3gRenew,
  getOoredoo3gNotRenew,
})(Ooredoo3g);
